const Header = require(`./${process.env.REACT_APP_STYLE}`).default;

export default Header;
